export enum ButtonStyle {
  SMALL_LINK,
  LARGE_LINK,
}
